import { ExtensionKey } from 'flow/types/EntityKeys';
import useAppContext from 'flow/hooks/useAppContext';
import { extractStatusFromProfile } from 'flow/utils';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectExtensionActiveProfile } from 'flow/selectors/ExtensionSelectors';

interface Props {
    extensionKey?: ExtensionKey;
}

const ActiveProfileStatus = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const activeProfile = useAppSelector((state) =>
        extensionKey ? selectExtensionActiveProfile(state, extensionKey) : null,
    );

    if (!activeProfile) {
        return null;
    }

    return <span>{extractStatusFromProfile(activeProfile, i18next)}</span>;
};

export default ActiveProfileStatus;
